import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PasscodeLock from '../components/PasscodeLock';
import usePasscodeStore from '../stores/passcodeStore';
import PenaltySettlementModal from '../components/PenaltySettlementModal';
import InfiniteScrollRestoration from '../components/InfiniteScrollRestoration';

const BaseLayout = () => {
  const isUnlocked = usePasscodeStore((state) => state.isUnlocked);
  const showPasscode = import.meta.env.VITE_SHOW_PASSCODE === 'true';

  // Show passcode lock if enabled and not unlocked
  if (showPasscode && !isUnlocked) {
    return <PasscodeLock />;
  }

  return (
    <>
      <InfiniteScrollRestoration />
      <div className="min-h-screen flex flex-col min-w-[1196px]">
        <Header />
        <main className="flex-grow flex">
          <Outlet />
        </main>
        <Footer />
      </div>
      <PenaltySettlementModal />
    </>
  );
};

export default BaseLayout;
